import $ from 'jquery';
import EFOcats_event_core from './efocats_event_core';

export default class EFOcats_event_box_change extends EFOcats_event_core {
  /**
   * イベント本体をセット
   */
  event() {
    this.$('body').on('change', '.box-label input', event => {
      const element = event.currentTarget;
      const type = $(element).attr('type');
      if (type === 'radio') {
        $(element).parents('.inner').find('.active').removeClass('active');
        $(element).parents('.box-label').addClass('active');
      } else if ($(element).is(':checked')) {
        $(element).parents('.box-label').addClass('active');
      } else {
        $(element).parents('.box-label').removeClass('active');
      }
    });
  }
}
